import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://esotechmalang.com/api/smbko/',
    headers: { 'Content-Type': 'application/json' }
})